module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), (_vm.item) ? _c('div', {
    staticClass: "section"
  }, [_c('dl', {
    staticClass: "dl-info"
  }, [_c('dt', [_vm._v("講師番号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.lecturer_no))]), _vm._v(" "), _c('dt', [_vm._v("メールアドレス")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.email))]), _vm._v(" "), _c('dt', [_vm._v("氏名")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('dt', [_vm._v("ふりがな")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.name_kana))]), _vm._v(" "), _c('dt', [_vm._v("生年月日（西暦）")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.birthday))]), _vm._v(" "), _c('dt', [_vm._v("住所")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.fullAddress))]), _vm._v(" "), _c('dt', [_vm._v("電話番号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.tel))]), _vm._v(" "), _c('dt', [_vm._v("協会ホームページ掲載")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.published ? 'する' : 'しない'))]), _vm._v(" "), _c('dt', [_vm._v("講師名（活動名）")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.lecturer_name))]), _vm._v(" "), _c('dt', [_vm._v("活動名 ふりがな")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.lecturer_name_kana))]), _vm._v(" "), _c('dt', [_vm._v("活動エリア１")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.active_area1))]), _vm._v(" "), _c('dt', [_vm._v("活動エリア２")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.active_area2))]), _vm._v(" "), _c('dt', [_vm._v("取得資格")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.qualification))]), _vm._v(" "), _c('dt', [_vm._v("自己紹介")]), _vm._v(" "), _c('dd', {
    staticClass: "pre-text"
  }, [_vm._v(_vm._s(_vm.item.introduction))]), _vm._v(" "), _c('dt', [_vm._v("始めたきっかけ")]), _vm._v(" "), _c('dd', {
    staticClass: "pre-text"
  }, [_vm._v(_vm._s(_vm.item.trigger))]), _vm._v(" "), _c('dt', [_vm._v("やってよかったこと")]), _vm._v(" "), _c('dd', {
    staticClass: "pre-text"
  }, [_vm._v(_vm._s(_vm.item.good_things))]), _vm._v(" "), _c('dt', [_vm._v("ホームページURL")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.homepage))]), _vm._v(" "), _c('dt', [_vm._v("FACEBOOKページ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.facebook))]), _vm._v(" "), _c('dt', [_vm._v("LINE@")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.line))]), _vm._v(" "), _c('dt', [_vm._v("Instagram")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.instagram))]), _vm._v(" "), _c('dt', [_vm._v("ブログ")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.item.blog))]), _vm._v(" "), _c('dt', [_vm._v("撮影会画像")]), _vm._v(" "), _c('dd', [(_vm.item.work_image1) ? _c('a', {
    attrs: {
      "href": _vm.item.work_image1
    }
  }, [_c('img', {
    staticClass: "col-12 col-sm-5 img-fluid",
    attrs: {
      "src": _vm.item.work_image1
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.item.work_image2) ? _c('a', {
    attrs: {
      "href": _vm.item.work_image2
    }
  }, [_c('img', {
    staticClass: "col-12 col-sm-5 img-fluid",
    attrs: {
      "src": _vm.item.work_image2
    }
  })]) : _vm._e()]), _vm._v(" "), _c('dt', [_vm._v("講師ステータス")]), _c('dd', [_c('lecturer-status', {
    attrs: {
      "statuses": _vm.lecturerStatusText
    }
  })], 1), _vm._v(" "), _c('dt', [_vm._v("プロフィール写真")]), _vm._v(" "), _c('dd', [(_vm.item.profile_image) ? _c('a', {
    attrs: {
      "href": _vm.item.profile_image
    }
  }, [_c('img', {
    staticClass: "col-12 col-sm-5 img-fluid",
    attrs: {
      "src": _vm.item.profile_image
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "group"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-outline-info btn-lg",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-secondary btn-lg",
    attrs: {
      "to": "/profile/edit"
    }
  }, [_vm._v("変更画面へ")])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-right mt-5"
  }, [_c('router-link', {
    attrs: {
      "to": "/mypage"
    }
  }, [_vm._v("マイページへのリンク")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('small', [_vm._v("講師詳細")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-02e338bd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lecturer/profile/Detail.vue
// module id = 314
// module chunks = 1